const mTheHeaderSubMenuDropDownAcademies = {
  mTheHeaderSubMenuDropDownAcademies: {
    alerts: {
      setCurrentAcademy: {
        error: 'Un error ha ocurrido. Inténtalo nuevamente en unos minutos.',
        success: 'Has cambiado de academia.'
      }
    }
  }
}

export default mTheHeaderSubMenuDropDownAcademies
